import { AppPlatform } from "app/types";

/**
 * サブスクリプション機能（表示・購入）をサポートしているかを判定する
 *
 * - Web / Amazon: 常にサポート
 * - Android: buildVersion 34 以上
 * - iOS: buildVersion 38 以上
 */
export const isSubscriptionSupported = (): boolean => {
  const platform = window.parentsAppPlatform || AppPlatform.Web;
  if (platform === AppPlatform.iOS) {
    return Number(window.parentsBuildVersion) >= 38;
  }
  if (platform === AppPlatform.Android) {
    return Number(window.parentsBuildVersion) >= 34;
  }
  return true;
};
